export const INITIAL_AGE = 72;
export const INITIAL_DISTRIBUTION_PERIOD = 27.4;
export const MAX_AGE = 119;
